require('./services/client-bills');

module.exports = 'client-bills';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/client-bills/index.js
 ** module id = 73
 ** module chunks = 1
 **/